import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, map, Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  AirportAdapterResponse,
  AirportData,
  Branding,
} from '../interfaces/results.interface';
import { AirportAdapter } from '../adapters/results.adapter';

@Injectable({
  providedIn: 'root',
})
export class ResultsService {
  private readonly baseUrl = environment.apiUrl;
  private readonly apiKey = environment.xapikey;

  private http = inject(HttpClient);
  headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('X-Api-Key', this.apiKey)
    .set('X-Canary', 'true');

  getAirport(query: string): Observable<AirportData[]> {
    const params = new HttpParams().set('query', query);

    return this.http
      .get<AirportAdapterResponse[]>(`${this.baseUrl}/airports`, {
        params,
        headers: this.headers,
      })
      .pipe(
        map((airports) => AirportAdapter(airports)),
        catchError(() => {
          return of([]);
        })
      );
  }
  getURL(id: string): Observable<Branding> {
    return this.http.get<Branding>(`${this.baseUrl}/${id}/motor-b2c/branding`, {
      headers: this.headers,
    });
  }
}
